const initialvalues = {
    setfilterOwnerDetailsbyRadio: [],
    setOwnerDetailsbyRadio: [],
    bakFlag: false,
    setDueDetails: [],

    formikValues: {},
    backFlag1: "fresh",

    payment: "",
}

export default function AuctionReducer(details = initialvalues, action) {

    switch (action.type) {
        case "TRADEPAYMENT": return { ...details, payment: action.payload };
        case "TRADESETOWNERDETAILSBYRADIO": return { ...details, setOwnerDetailsbyRadio: action.payload };
        case "TRADESETFILTEROWNERDETAILSBYRADIO": return { ...details, setfilterOwnerDetailsbyRadio: action.payload };
        case "TRADESETDUEDETAILS": return { ...details, setDueDetails: action.payload };
        case "TRADEFORMIKVALUES": return { ...details, formikValues: action.payload };
        case "TRADEBACKFLAG": return { ...details, bakFlag: action.payload };
        case "TRADEBACKFLAG1": return { ...details, bakFlag1: action.payload };
        default: return details;
    }
}